/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import DatepickerRange from 'components/datepicker-range/datepicker-range';
import AgreementsService from 'frilans-finans/agreements/agreement-service';
import SpinnerButton from 'components/spinner-button/spinner-button';
import Spinner from 'components/spinner/spinner';
import Utils from 'frilans-finans/utils/utils';

export class AgreementsList extends React.Component {

  static propTypes = {
    dateFilter: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetchingMore: false,
      fetchingInitial: true,
      contentFetched: false,
      fetchError: false,
      agreements: [],
      meta: {
        currentPage: 0
      },
      pendingRequest: null
    };

    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.fetchAgreements = this.fetchAgreements.bind(this);
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.dateFilter.startDate !== this.props.dateFilter.startDate ||
      nextProps.dateFilter.endDate !== this.props.dateFilter.endDate) {
      this.props = nextProps;

      this.setState({
        fetchingMore: true,
        agreements: [],
        fetchingInitial: true,
        meta: {
          currentPage: 0
        }
      }, this.fetchAgreements);
    }
  }

  componentDidMount () {
    this.fetchAgreements();
  }

  fetchAgreements () {
    let filter = this.props.dateFilter;
    let page = this.state.meta.currentPage + 1;
    let userId = this.props.user.id;

    this.setState({
      fetchingMore: true
    }, () => {
      let pendingRequest = AgreementsService.get(filter, page, userId);
      pendingRequest.promise
        .then(this.handleSuccess)
        .catch(this.handleError);

      this.setState({
        pendingRequest: pendingRequest
      });
    });
  }

  handleSuccess (response) {
    this.setState({
      agreements: this.state.agreements.concat(response.collection),
      fetchingInitial: false,
      fetchingMore: false,
      contentFetched: true,
      fetchError: false,
      meta: response.meta
    });
  }

  handleError (error) {
    if (error.response !== undefined) {
      this.setState({
        fetchingInitial: false,
        contentFetched: true,
        fetchError: true
      });
    }
  }

  renderError () {
    return (<p className='error'><Translate content='GENERAL_ERROR'/></p>);
  }

  renderNoResult () {
    return (<p className='info'><Translate content='NO_CONTRACTS'/></p>);
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderTableWrapper () {
    return (
      <div>
        {this.renderTable()}
        {this.renderShowMoreBtn()}
      </div>
    );
  }

  renderTable () {
    return (
      <table className='standard-table'>
        <thead>
          <tr>
            <th className='col-contract'><Translate content='CONTRACTS'/></th>
            <th className='col-ordernr'><Translate content='ORDER_NR'/></th>
            <th className='col-created'><Translate content='CREATED'/></th>
            <th className='col-cond'><Translate content='CONDITIONS'/></th>
          </tr>
        </thead>
        <tbody>
          {this.state.agreements.map(this.renderTableRow)}
        </tbody>
      </table>
    );
  }

  renderTableRow (row, i) {
    return (
      <tr key={i}>
        <td className='col-contract'>
          <Link to={'/economy/agreements/' + row.agreement.id} className='pointer-link desktop'>
            <Translate content='CONTRACT_SHORT_TERM'/>
          </Link>
          <Link to={'/economy/agreements/' + row.agreement.id} className='pointer-link mobile'/>
        </td>
        <td className='col-ordernr'>{row.agreement.invoiceId}</td>
        <td className='col-created'>
          <Translate content='CREATED_DATE' date={Utils.formatDate(row.agreement.createdAt)} />
        </td>
        <td className='col-cond'>
          <Link to={'/economy/agreements/' + row.condition.id} className='pointer-link desktop'>
            <Translate content='GENERAL_TERMS'/>
          </Link>
          <Link to={'/economy/agreements/' + row.condition.id} className='pointer-link mobile'/>
        </td>
      </tr>
    );
  }

  renderShowMoreBtn () {
    if (this.state.meta.currentPage < this.state.meta.totalPages && !this.state.fetchingInitial) {
      return (
        <div className='show-more-btn-wrapper'>
          <SpinnerButton text={proxyCounterpart('SHOW_MORE')} graySpinner='true'
            loading={this.state.fetchingMore} classes='btn white show-more' callback={this.fetchAgreements}/>
        </div>
      );
    }

    return false;
  }

  renderContent () {
    if (this.state.fetchError) {
      return this.renderError();
    }
    if (this.state.fetchingInitial) {
      return this.renderLoader();
    }
    if (this.state.agreements.length === 0 && this.state.contentFetched) {
      return this.renderNoResult();
    } else {
      return this.renderTableWrapper();
    }
  }

  render () {
    return (
      <div className='agreements-list'>

        <h2><Translate content='CONTRACT_FF'/></h2>
        <p><Translate content='CONTRACT_FF_TEXT'/></p>

        <DatepickerRange />

        <div className='table-wrapper mobile-full-width-table'>
          {this.renderContent()}

        </div>
      </div>
    );
  }
}

export default AgreementsList;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/agreements/agreements-list.js
 **/